import { MSG_CAMPO_OBRIGATORIO_GERAL, ALERTA } from 'utils/consts';
import { fetchNotificationApp, fetchStatusModal } from 'store/fetchActions/fetchApp';
import { validationsPessoaCreate } from 'utils/validate/dadosCadastrais';
import { validarExibirErrosCampos } from 'utils/formUtils';

export const isValidForSubmit = (dadosInputs, setError) => dispatch => {
  const isValid = validarExibirErrosCampos(dadosInputs, dados => validationsPessoaCreate(dados, true), setError);

  if (!isValid) {
    dispatch(exibirNotificacaoErroCampo());
  }
  return isValid;
};

export const exibirNotificacaoErroCampo = (descricaoMensagem = '') => dispatch => {
  dispatch(fetchStatusModal(false, ''));
  fetchNotificationApp(MSG_CAMPO_OBRIGATORIO_GERAL, descricaoMensagem, ALERTA.ERRO);
};
